import { render } from "./GroupMemberAdder.vue?vue&type=template&id=44f589be"
import script from "./GroupMemberAdder.vue?vue&type=script&lang=js"
export * from "./GroupMemberAdder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__